import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { AppConfig } from 'pmn/types';

export const initSentry = ({
  SENTRY_CLIENT_DSN,
  SENTRY_ENABLED,
}: AppConfig): typeof Sentry => {
  if (!SENTRY_ENABLED) {
    return Sentry;
  }

  Sentry.init({
    dsn: SENTRY_CLIENT_DSN,

    denyUrls: [
      // Facebook blocked
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /onloadwff\.js/,
    ],
    beforeSend(event) {
      if (
        event.request &&
        event.request.url &&
        event.request.url.indexOf('worker.js') > -1
      ) {
        return null;
      }

      return event;
    },
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.3,
  });

  return Sentry;
};
